import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'rt_zzfld000016': {
    title: '客户类型',
    type: 'select',
    equation: all,
    dictionary: 'A0009'
  },
  'rt_partner': {
    title: '客户编码',
    type: 'input',
    equation: all
  },
  'rt_name_org1': {
    title: '客户名称',
    type: 'input',
    equation: all
  },
  'rt_sal_center': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  }
}

export default {
  'partner': {
    title: '客户编号',
    width: 180
  },
  'name_org1': {
    title: '客户名称',
    width: 250
  },
  'zzfld000016_text': {
    title: '客户类型'
  },
  'zzfld00002r': {
    title: '手机号'
  },
  'zzfld000017': {
    title: '旧编码'
  },
  'zzfld000018': {
    title: '法人姓名'
  },
  'zzfld000019': {
    title: '法人电话'
  },
  'zzfld00001a': {
    title: '统一社会信用代码',
    width: 180
  },
  'sales_emp': {
    title: '负责员工编号'
  },
  'sales_emp_name': {
    title: '负责人姓名'
  },
  'crdat': {
    title: '创建日'
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog/config/ClientSelect.js